"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const DynamicSchemaSection_1 = require("./DynamicSchemaSection");
class DynamicSchemaDefinition {
    constructor({ id, sections }) {
        this.toJSON = () => ({
            id: this.id,
            sections: this.sections.toJSON().map(section => section.toJSON()),
        });
        this.id = id;
        this.sections = sections;
    }
}
DynamicSchemaDefinition.fromJSON = (json) => {
    const { id, sections } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (!(Array.isArray(sections) || immutable_1.List.isList(sections)))
        throw new Error('.sections must be an array');
    return new DynamicSchemaDefinition({
        id,
        sections: immutable_1.List(sections).map(section => DynamicSchemaSection_1.default.fromJSON(section)),
    });
};
exports.default = DynamicSchemaDefinition;
